import axios from "axios";

const API = "/api";

export const submitContact = (data) => axios.post(`${API}/contact.php`, data, { timeout: 20000 });
export const submitVolunteer = (data) => axios.post(`${API}/volunteer.php`, data, { timeout: 20000 });
export const submitPartnership = (data) => axios.post(`${API}/partnership.php`, data, { timeout: 20000 });
export const subscribe = (email) => axios.post(`${API}/subscribe.php`, { email }, { timeout: 20000 });

export const fetchPartners = () => axios.get(`${API}/partners.php`, { timeout: 8000 });
export const fetchGallery = () => axios.get(`${API}/gallery.php`, { timeout: 8000 });
export const fetchTestimonials = () => axios.get(`${API}/testimonials.php`, { timeout: 8000 });
export const fetchSiteSettings = () => axios.get(`${API}/settings.php`, { timeout: 8000 });
export const fetchImpactStats = () => axios.get(`${API}/impact-stats.php`, { timeout: 8000 });
export const fetchPrograms = () => axios.get(`${API}/programs.php`, { timeout: 8000 });
